var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodesandbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.795 9.253l9.126 5.179 9.147-5.223-4.837-2.745-4.261 2.431-4.286-2.459-4.89 2.818zM26.406 11.603l-9.144 5.195v10.337l4.964-2.869v-4.391l4.18-2.326v-5.946zM5.488 11.603v5.945l4.18 2.324v4.394l4.964 2.869v-10.337zM2.879 8.502l13.065-7.498 13.065 7.498 0.112 14.933-13.177 7.56-13.065-7.498z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodesandbox);
export default __webpack_public_path__ + "static/media/codesandbox.0a36b036edebc0a7a554c58c60224620.svg";
export { ForwardRef as ReactComponent };